import styled from '@emotion/styled';
import { colors } from 'constants/colors';
import { CondizioniTransitabilitaL3 } from 'constants/inspections';
import { statusInspections } from './constants';

export const BoxContainer = styled('div')(
  ({
    status,
    isSpecialInspection,
    isRischioFrane,
    isVerifica,
    isTransitabilitaIdraulica,
  }) => ({
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    borderRadius: 8,
    //   cursor: 'pointer',
    border: isTransitabilitaIdraulica
      ? status === CondizioniTransitabilitaL3.Operativo ||
        status === CondizioniTransitabilitaL3.Transitabile
        ? `1px solid ${colors.BLUE}`
        : `1px solid ${colors.PALAGREY}`
      : status >= 1 && isRischioFrane
      ? `1px solid ${colors.BLUE}`
      : status === statusInspections.PresenteNecessario
      ? `1px solid ${colors.BLUE}`
      : status === 3 && isVerifica
      ? `1px solid ${colors.BLUE}`
      : status === statusInspections.NecessitaIspezioniSpeciali &&
        isSpecialInspection
      ? `1px solid ${colors.RED}`
      : status === 3 && !isSpecialInspection
      ? `1px solid ${colors.PALAGREY}`
      : `1px solid ${colors.PALAGREY}`,
    backgroundColor: isTransitabilitaIdraulica
      ? status === CondizioniTransitabilitaL3.Operativo ||
        status === CondizioniTransitabilitaL3.Transitabile
        ? colors.BLUE
        : status === CondizioniTransitabilitaL3.Adeguato
        ? colors.GREY
        : colors.WHITE
      : status >= 1 && isRischioFrane
      ? colors.BLUE
      : status === statusInspections.PresenteNecessario
      ? colors.BLUE
      : status === 3 && isVerifica
      ? colors.BLUE
      : status === statusInspections.NecessitaIspezioniSpeciali &&
        isSpecialInspection
      ? colors.RED
      : status === statusInspections.AssenteNonNecessario
      ? colors.GREY
      : isSpecialInspection
      ? colors.GREY
      : status === 3 && !isSpecialInspection
      ? colors.WHITE
      : colors.WHITE,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: 16,
  })
);

export const IconContainer = styled('div')(
  ({ status, isSpecialInspection, isTransitabilitaIdraulica }) => ({
    width: 40,
    height: 40,
    borderRadius: '100%',
    border: isTransitabilitaIdraulica
      ? status === CondizioniTransitabilitaL3.Operativo ||
        status === CondizioniTransitabilitaL3.Transitabile
        ? `1px solid ${colors.BLUE}`
        : `1px solid ${colors.PALAGREY}`
      : (!status || (status === 3 && !isSpecialInspection)) &&
        `1px solid ${colors.PALAGREY}`,
    backgroundColor: colors.WHITE,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  })
);

export const ArrowIcon = styled('img')({
  cursor: 'pointer',
  marginLeft: 8,
  width: 12,
  height: 12,
});
